import { render } from "./dl-modal.vue?vue&type=template&id=2f6ffcc3"
import script from "./dl-modal.vue?vue&type=script&lang=js"
export * from "./dl-modal.vue?vue&type=script&lang=js"

import "./dl-modal.vue?vue&type=style&index=0&id=2f6ffcc3&lang=scss"

import exportComponent from "/var/www/doctolib-hos-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__